import gameListStore from '@modules/game/game-list-store';
import gameViewStore from '@modules/game/game-view-store';
import gameImporterStore from '@modules/game/game-importer-store';
import gameFormStore from '@modules/game/game-form-store';
import gameDestroyStore from '@modules/game/game-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: gameDestroyStore,
    form: gameFormStore,
    list: gameListStore,
    view: gameViewStore,
    importer: gameImporterStore,
  },
};
